import * as React from "react";
import {  ChevronRight, Loader2 } from "lucide-react";
import { useSelector } from "react-redux";
import StudentRankingStats from "./StudentRankingStats";
import StudentPredictionsCards from "./StudentPredictionsCards";
import StudentRankingCharts from "./StudentRankingCharts";
import StudentRankingOverview from "./StudentRankingOverview";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Skeleton } from "../ui/skeleton";
import { useGetRankingQuery } from "@/store/ranking/rankingApi";
import FinalInterviewEligibilityCard from "./FinalInterviewEligibilityCard";
import { RootState } from "@/types";
import RankingErrorHandler from "./RankingErrorHandler";

const Ranking = () => {
  const { user } = useSelector((state: RootState) => state.user);

  const { data: rankingDat, error } = useGetRankingQuery({
    studentId: user._id,
    batchCode: user.batch._id,
  });

  console.log(rankingDat , "data ")
  const rankingData = rankingDat?.data?.ranking;

  // /Final eligibility
  const interviewScore = Math.round(rankingData?.interviewScore || 0);
  const assignmentScore = Math.round(rankingData?.assignmentScore || 0);
  const taskScore = Math.round(rankingData?.taskScore || 0);

  if (!rankingData && !error) {
    return (
      <div className="min-h-screen bg-gray-50 p-6 flex items-center justify-center">
        <Card className="w-full max-w-md text-center border-0 shadow-sm">
          <CardHeader>
            <CardTitle className="flex flex-col items-center justify-center gap-3">
              <Loader2 className="h-8 w-8 text-[#26BDB0] animate-spin" />
              <span className="text-lg text-gray-900 font-medium">
                Loading your ranking data...
              </span>
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 mt-4">
            <Skeleton className="h-4 w-3/4 mx-auto" />
            <Skeleton className="h-4 w-1/2 mx-auto" />
          </CardContent>
        </Card>
      </div>
    );
  }

  if (error) {
    return <RankingErrorHandler />;
  }

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="mx-auto max-w-7xl space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-foreground mb-1">
              Student Performance Analytics
            </h1>
            <div className="text-sm text-gray-500 flex items-center gap-2">
              <span>Dashboard</span>
              <ChevronRight className="w-3 h-3" />
              <span className="text-gray-700">Ranking</span>
            </div>
          </div>
        </div>

        <FinalInterviewEligibilityCard
          interviewScore={interviewScore}
          assignmentScore={assignmentScore}
          taskScore={taskScore}
        />

        {/* Top Stats Row */}
        <StudentRankingStats myRanking={rankingDat} rankingData={rankingData} />

        {/* Predictions Card */}
        <StudentPredictionsCards rankingData={rankingData} />

        {/* Charts Section */}
        <StudentRankingCharts rankingData={rankingData} />

        {/* Bottom Section */}
        <StudentRankingOverview rankingData={rankingData} />
      </div>
    </div>
  );
};

export default Ranking;
